export const config = {
  API_URL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
  COGNITO: {
    REGION: process.env.REACT_APP_AWS_REGION || 'us-east-1',
    USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID || '',
    USER_POOL_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID || '',
  }
};

